import {
    GET_USER,
    EDIT_USER,
    ADD_USER,
    ALL_USER
  } from "./actionTypes"

  export const allUser = user => {
    return {
      type: ALL_USER,
      payload: user,
    }
  }

  export const getUser = (user) => {
    return {
      type: GET_USER,
      payload: {user},
    }
  }

  export const editUser =  (user,history) => {
    return {
      type: EDIT_USER,
      payload: { user,history},
    }
  }

  export const addUser =  (user,history) => {
    return {
      type: ADD_USER,
      payload: {user,history},
    }
  }